import { render, staticRenderFns } from "./SsoLoginPage.vue?vue&type=template&id=6a2dfc16&"
import script from "./SsoLoginPage.vue?vue&type=script&lang=js&"
export * from "./SsoLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports